<template>
  <div v-show="menuActive" class="type-menu">
    <div class="menu-backdrop" @click="closeMenu" @contextmenu.prevent />
    <div class="menu" ref="menu" @click="closeMenu">
      <div class="info">Zmień typ:</div>
      <button v-for="typeInfo in allowedTypes" @click="changeType(typeInfo.type)">
        <div class="icon md-icon">{{ typeInfo.icon }}</div>
        {{ typeText(typeInfo.type) }}
      </button>
      <template v-if="item?.type === 'task' && false">
        <div class="info">Zmień ikonę:</div>
        <div class="icons">
          <button @click="changeIcon(undefined)">
            <div class="icon md-icon">check_box</div>
          </button>
          <button @click="changeIcon('flag')">
            <div class="icon md-icon">flag</div>
          </button>
          <button @click="changeIcon('favorite')">
            <div class="icon md-icon">favorite</div>
          </button>
          <button @click="changeIcon('help')">
            <div class="icon md-icon">help</div>
          </button>
        </div>
      </template>
    </div>
  </div>
</template>

<style scoped>
.menu-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  background: var(--bg-color-hover);
}
.menu {
  z-index: 15;
  position: fixed;
  border-radius: var(--rounding-smaller);
  background-color: var(--bg-color-card-default);
  border: var(--menu-border);
  display: flex;
  flex-flow: column nowrap;
  max-height: 90vh;
  overflow-y: auto;
}
.info {
  padding: 4px 8px;
  font-size: var(--text-size-tertiary);
  font-weight: 500;
  opacity: var(--text-opacity-tertiary);
}
.icons {
  display: flex;
}
.icons button {
  min-width: var(--indent-size);
}

.icon {
  flex: var(--indent-size) 0 0;
  margin: 0;
}
button {
  min-height: var(--indent-size);
  min-width: 150px;
  display: flex;
  align-items: center;
  border: none;
  background-color: transparent;
  cursor: pointer;
}
button:hover {
  background: var(--bg-color-hover);
}
</style>

<script>
import { REL_ELEM, allowedChildInfo } from "@/structure";

export default {
  data() {
    return {
      menuActive: false,
      triggerEl: null,
      item: null,
    };
  },
  computed: {
    allowedTypes() {
      if (this.item) {
        if (this.item.type === "date") {
          return [];
        }
        const mainParent = this.item.getParent(REL_ELEM);
        return allowedChildInfo(mainParent);
      }
      return [];
    },
  },
  methods: {
    changeIcon(icon) {
      this.item.clone({ icon }).save();
    },
    changeType(type) {
      // TODO sprawdzać czy można konwertować na dany typ (np. subtask nie może zostać listą)
      this.item.clone({ type, icon: undefined }).save();
    },
    typeText(type) {
      switch (type) {
        case "task":
          return "zadanie";
        case "note":
          return "notatka";
      }
    },
    openMenu() {
      if (this.allowedTypes.length > 1) {
        this.menuActive = true;
        this.$nextTick(() => {
          // we need the size for calculations, so it has to render first
          this.setMenuPosition(this.$refs.menu);
        });
      }
    },
    setMenuPosition(menu) {
      const viewport = document.getElementById("toplevel").getBoundingClientRect();

      const width = menu.offsetWidth;
      if (viewport.width > this.triggerEl.left + width) {
        menu.style.left = this.triggerEl.left + "px";
        menu.style.right = "auto";
      } else if (this.triggerEl.right > width) {
        menu.style.right = viewport.width - this.triggerEl.right + "px";
        menu.style.left = "auto";
      } else {
        menu.style.left = "5vw";
        menu.style.right = "auto";
      }

      const height = menu.offsetHeight;
      if (viewport.height > this.triggerEl.top + height) {
        menu.style.top = this.triggerEl.top + "px";
        menu.style.bottom = "auto";
      } else if (this.triggerEl.bottom > height) {
        menu.style.bottom = viewport.height - this.triggerEl.bottom + "px";
        menu.style.top = "auto";
      } else {
        menu.style.bottom = "5vh";
        menu.style.top = "auto";
      }
    },
    closeMenu() {
      this.menuActive = false;
    },
  },
  mounted() {
    this.$root.$on("type-menu", (data) => {
      this.triggerEl = data.button;
      this.item = data.item;
      this.openMenu();
    });
  },
};
</script>
